import { catchError, map } from 'rxjs/operators';
import { of, Observable, forkJoin } from 'rxjs';
import { deepmerge } from 'deepmerge-ts';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';

export class MultiTranslateHttpLoader implements TranslateLoader {
  private translationDirectories = ['/assets/i18n/core', '/assets/i18n/translations'];

  constructor(private _handler: HttpBackend) {}

  public getTranslation(lang: string): Observable<TranslationObject> {
    const requests: Array<Observable<TranslationObject>> = this.translationDirectories.map(i18n_dir =>
      new HttpClient(this._handler).get<TranslationObject>(`${i18n_dir}/${lang}.json`).pipe(catchError(err => of({})))
    );

    return forkJoin(requests).pipe(map(translations => deepmerge(...translations) as TranslationObject));
  }
}
